/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Private Data Enclave API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {GetInvestigatorsByStudyIRBNumberParams, IRBInvestigatorsResponse} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}

@Injectable({providedIn: 'root'})
export class IrbProtocolsService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * Returns True if the given study_irb_number is ACTIVE.
   * @summary Get Active Status By Study Irb Number
   */
  getActiveStatusByStudyIrbNumber<TData = boolean>(
    studyIrbNumber: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getActiveStatusByStudyIrbNumber<TData = boolean>(
    studyIrbNumber: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getActiveStatusByStudyIrbNumber<TData = boolean>(
    studyIrbNumber: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getActiveStatusByStudyIrbNumber<TData = boolean>(
    studyIrbNumber: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/irb-protocols/${studyIrbNumber}/active`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/irb-protocols/${studyIrbNumber}/active`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/irb-protocols/${studyIrbNumber}/active`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets a list of investigators (emails) of a study identified by IRB number. When "project-id" is sent
   * as a query parameter, only users who are on the IRB protocol and associated with the project are returned
   * @summary Get Investigators By Study Irb Number
   */
  getInvestigatorsByStudyIRBNumber<TData = IRBInvestigatorsResponse[]>(
    studyIrbNumber: string,
    params?: GetInvestigatorsByStudyIRBNumberParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getInvestigatorsByStudyIRBNumber<TData = IRBInvestigatorsResponse[]>(
    studyIrbNumber: string,
    params?: GetInvestigatorsByStudyIRBNumberParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getInvestigatorsByStudyIRBNumber<TData = IRBInvestigatorsResponse[]>(
    studyIrbNumber: string,
    params?: GetInvestigatorsByStudyIRBNumberParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getInvestigatorsByStudyIRBNumber<TData = IRBInvestigatorsResponse[]>(
    studyIrbNumber: string,
    params?: GetInvestigatorsByStudyIRBNumberParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/irb-protocols/${studyIrbNumber}/users`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/irb-protocols/${studyIrbNumber}/users`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/irb-protocols/${studyIrbNumber}/users`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
}
